import React from 'react';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import GroupsIcon from '@mui/icons-material/Groups';
import DevicesIcon from '@mui/icons-material/Devices';
import FilterNoneIcon from '@mui/icons-material/FilterNone';
import PersonIcon from '@mui/icons-material/Person';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import Strings from '../../../i18n';
import { systemModuleEnum } from '../../../constants/systemRolesEnums';

export const itemsServerAccessMenu: {
  icon: React.ReactNode;
  text: string;
  url: string;
  key: string;
}[] = [
  {
    icon: <MonitorHeartIcon />,
    text: Strings.serverAccess.menu.serviceHealth,
    url: '/health-monitor',
    key: systemModuleEnum.serviceHealth
  },
  {
    icon: <GroupsIcon />,
    text: Strings.serverAccess.menu.organizations,
    url: '/organizations',
    key: systemModuleEnum.organizations
  },
  {
    icon: <DevicesIcon />,
    text: Strings.serverAccess.menu.versions,
    url: '/firmwareVersions',
    key: systemModuleEnum.versions
  },
  {
    icon: <FilterNoneIcon />,
    text: Strings.serverAccess.menu.productsModels,
    url: '/',
    key: systemModuleEnum.products
  },
  {
    icon: <PersonIcon />,
    text: Strings.serverAccess.menu.users,
    url: '/users',
    key: systemModuleEnum.users
  },
  {
    icon: <LocationOnIcon />,
    text: Strings.serverAccess.menu.locations,
    url: '/all-locations',
    key: systemModuleEnum.locations
  },
  {
    icon: <PhoneAndroidIcon />,
    text: Strings.serverAccess.menu.devices,
    url: '/server-access/devices',
    key: systemModuleEnum.devices
  },
  {
    icon: <PhoneAndroidIcon />,
    text: Strings.serverAccess.menu.deviceAnnounce,
    url: '/server-access/device-announce',
    key: systemModuleEnum.deviceAnnounce
  }
];
